import type { OrgRegulatingFilter } from '../generated/resolvers'
import request from '../requesters/search'

export const orgRegulatingFiltersDiscovery = async () => {
  const response = await request.get<OrgRegulatingFilter>('/discovery/regulating_organisations')

  return response.data || null
}
